<div class="d-flex justify-content-center">
    <div class="d-flex flex-column page-container">
        <div class="card not-found-box m-3 h-100 justify-content-center align-items-center">
            <img src="assets/images/404.png" class="not-found-img" />
            <section class="d-flex title">
                Page not found
            </section>
            <section class="d-flex flex-column caption">
                <span>The page you requested can't be found.</span>
                <span>Try refreshing the page or go back later.</span>
            </section>
        </div>
    </div>
</div>
